module.exports = __webpack_public_path__ + "static/media/close-k-12.a0e0585f.png";